import React from "react";

import { Show, SimpleShowLayout, TextField } from "react-admin";

import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { JsonTextField } from "../../../components/fields/JsonTextField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { ClientNotificationDeliveryStatus } from "../../../entities/ClientNotificationDeliveryStatus";
import { NotificationSubscriptionEventType } from "../../../entities/NotificationSubscriptionEventType";
import { ReplayButton } from "../Buttons/ReplayButton";

export const ClientNotificationDeliveryShow = (props) => (
	<Show actions={<ActionsWithBackButton />} {...props}>
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="subscription_id" />
			<TextField source="delivery_id" />
			<SelectEnumField
				source="event_type"
				enumObj={NotificationSubscriptionEventType}
				enumName="notification_subscription"
			/>
			<SelectEnumField
				source="status"
				enumObj={ClientNotificationDeliveryStatus}
				enumName="client_notification_delivery_status"
			/>
			<TextField source="attempts" />
			<TextField source="callback_url" />
			<TextField source="response_code" />
			<TextField source="last_error" style={{ whiteSpace: "pre-wrap" }} />
			<JsonTextField source="response_body_excerpt" />
			<JsonTextField source="payload_body" />
			<DateTimeField source="created_at_utc" withLocalTimeZone addLabel />
			<DateTimeField source="last_attempt_at_utc" withLocalTimeZone addLabel />
			<DateTimeField source="next_retry_at_utc" withLocalTimeZone addLabel />
			<DateTimeField source="delivered_at_utc" withLocalTimeZone addLabel />
			<ReplayButton />
		</SimpleShowLayout>
	</Show>
);
